module.exports = __webpack_public_path__ + "img/snow_fall_00040.cc46f66d.png";